import React, { useState, useEffect, useRef } from "react";
import LoadFile from "../../assets/icons/LoadFile.svg";
import UploadFile from "../../assets/icons/UploadFile.svg";
import DocInfo from "../../assets/icons/DocInfo.svg";
import DocInfo2 from "../../assets/icons/DocInfo2.svg";
import IconUpload from "../../assets/icons/IconUpload.svg";
import { useDropzone } from "react-dropzone";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
//icons
import arrowSimple from "../../assets/icons/arrowSimple.svg";
import * as Constant from "../../global/const";
import Loader from "react-loader-spinner";
import { Markup } from "interweave";
import auth from "../../Helpers/auth";
//axios
import axios from "axios";
import Dropzone from "react-dropzone";
import CabezoteComponent from "../../Components/Cabezote/cabezote.component";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ModalNotificacion from "../Cabezote/Notificacion/modalNotificacion.component";
import httpClient from "../../Util/httpClient";

const Content = () => {
  const [content, setcontent] = useState("carga");
  const [open, setOpen] = useState(false);
  const [close, setclose] = useState(true);
  const [mostrarOpciones, setMostrarOpciones] = useState(false);
  const url = `${Constant.URL_BASE_IMAGES}web/FormatoCargaMasiva.xlsx`;
  //ESPERAR RUTA

  const downloadCSV = async (url, name) => {
    const response = await fetch(url);
    const data = await response.text();
    const blob = new Blob([data], { type: "data:text/csv;charset=utf-8," });
    const blobURL = window.URL.createObjectURL(blob);
    // Create new tag for download file
    const anchor = document.createElement("a");
    anchor.download = name;
    anchor.href = blobURL;
    anchor.dataset.downloadurl = [
      "text/csv",
      anchor.download,
      anchor.href,
    ].join(":");
    anchor.click();
    // Remove URL.createObjectURL. The browser should not save the reference to the file.
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      URL.revokeObjectURL(blobURL);
    }, 100);
  };

  return (
    <div className="home">
      <CabezoteComponent
        open={open}
        setOpen={setOpen}
        tipo={false}
        categoriasGlobal={null}
        close={close}
        setclose={setclose}
        mostrarOpciones={mostrarOpciones}
        setMostrarOpciones={setMostrarOpciones}
      />
      <div className="contentMasiva">
        <div className="HeaderMasiva">
          <div>
            <img src={LoadFile} alt="" />
            <h1>Carga masiva de pedidos</h1>
          </div>
          <p>
            Realiza la carga de tus pedidos de forma centralizada y rápida para
            los puntos de venta que requieras.
          </p>
        </div>
        <div className="contentOpciones ">
          <div
            className="content-card "
            onClick={() => setcontent("instrucciones")}
          >
            <div
              className="CardOpcion no-seleccionable"
              style={
                content === "instrucciones"
                  ? { backgroundColor: "#0075BB" }
                  : { backgroundColor: "#FFF" }
              }
            >
              <img
                src={content === "instrucciones" ? DocInfo2 : DocInfo}
                alt=""
              />
              <span
                style={
                  content === "instrucciones"
                    ? { color: "#FFF" }
                    : { color: "#0075BB" }
                }
              >
                Leer instrucciones
              </span>
            </div>
            <p>
              Si tienes dudas, encuentra aquí cómo subir tus pedidos
              correctamente.
            </p>
          </div>
          <div className="content-card ">
            <a
              href={url}
              // onClick={() => { downloadCSV(url, "FormatoCargaMasiva (16).csv") }}
              download
              className="CardOpcion no-seleccionable"
            >
              <img src={UploadFile} alt="" />
              <span>Descargar plantilla</span>
            </a>
            <p> Formato para cargar tus pedidos masivamente.</p>
          </div>
        </div>
        <div className="BodyMasiva">
          {content === "instrucciones" ? (
            <Instrucciones setcontent={setcontent} />
          ) : (
            <CargarPedidos />
          )}
        </div>
      </div>
    </div>
  );
};

const CargarPedidos = () => {
  const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 15,
      borderRadius: 5,
      width: "100%",
    },
    colorPrimary: {
      backgroundColor:
        theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
    },
    bar: {
      borderRadius: 5,
      backgroundColor: "#EFB71B",
    },
  }))(LinearProgress);

  const [File, setFile] = useState(null);
  const [stateLoad, setstateLoad] = useState(0);
  const [content, setcontent] = useState(1);
  const [response, setResponse] = useState();
  const [numProducts, setNumProducts] = useState(0);
  const [error, setError] = useState();
  const [idcg, setIdcg] = useState();
  const [message, setMessage] = useState();
  const [messageSend, setMessageSend] = useState();
  const [load, setLoad] = useState();
  const cancelToken = useRef(null);
  const [fileSize, setFileSize] = useState(0); // Estado para almacenar el tamaño del archivo
  const [estimatedDuration, setEstimatedDuration] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [errorMessage, setErrorMessage] = useState({});
  const [showModal, setShowModal] = useState(false);
  let history = useHistory();

  let user = JSON.parse(auth.getUsuario());
  const { isDragActive, getRootProps, getInputProps, open, acceptedFiles, is } =
    useDropzone({
      noClick: false,
      accept: ".XLSX,.XLS",
    });

  const handleDrop = () => {
    let adition = "";
    if (acceptedFiles.length > 0) {
      adition = "-activo";
    } else {
      adition = "";
    }

    return adition;
  };

  useEffect(() => {
    setFile(acceptedFiles[0]);
    setcontent(1);
    setError(null);
  }, [acceptedFiles]);

  const files = acceptedFiles.map((file) => {
    return <li key={file.path}>{file.path}</li>;
  });

  const leerArchivoExcel = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (event) {
        try {
          const data = event.target.result;

          // Función para convertir el array de bytes en texto CSV
          function arrayBufferToCSV(buffer) {
            const decoder = new TextDecoder("utf-8");
            let csv = decoder.decode(buffer);
            return csv;
          }

          // Convertir el array de bytes a texto CSV
          const csv = arrayBufferToCSV(data);

          // Separar el CSV en filas
          const filas = csv.split("\n");

          // Array para almacenar las plantas únicas
          const plantasUnicas = [];

          // Iterar sobre las filas y obtener la planta de cada una
          for (let i = 1; i < filas.length; i++) {
            const fila = filas[i].split(",");
            if (fila.length >= 6) {
              const planta = fila[5].trim();
              // Si la planta no está en el array de plantas únicas, agregarla
              if (!plantasUnicas.includes(planta)) {
                plantasUnicas.push(planta);
              }
            }
          }

          resolve(plantasUnicas.length);
        } catch (error) {
          reject(0);
        }
      };
      reader.onerror = function (error) {
        reject(0);
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const calcularAproximacionTime = async (file, datoEstimado) => {
    try {
      const plantasUnicas = await leerArchivoExcel(file);
      let duration = parseFloat(plantasUnicas * 14 * 1000) ?? 0;
      let estimacionTotal = Number(duration + datoEstimado);
      setEstimatedDuration(estimacionTotal);
    } catch (error) {
      setEstimatedDuration(datoEstimado);
    }
  };

  const uploadFileNew = async () => {
    setError(null);
    setstateLoad(0);
    if (File === null) {
      return;
    }
    getFileSize(File);
    setStartTime(Date.now());
    setTimeout(() => {
      setstateLoad(15);
    }, 500);
    const formData = new FormData();
    formData.append("file", File);
    formData.append("correo", user.email);
    cancelToken.current = axios.CancelToken.source();
    setTimeout(() => {
      setstateLoad(30);
    }, 1000);

    const config = {
      cancelToken: cancelToken.current.token,
      timeout: 0,
    };
    setTimeout(() => {
      setstateLoad(50);
    }, 1000);
    const instance = axios.create({
      timeout: null, // Sin límite de tiempo
    });
    calculateProgress();

    httpClient
      .post(Constant.UPLOADFILE, formData, config)
      .then((res) => {
        setError(null);
        setEstimatedDuration(0);
        setStartTime(null);
        setTimeout(() => {
          setstateLoad(100);
          if (res.data.estado == "Error") {
            setResponse(res.data.registros);
            setIdcg(res.data.idCargueMasivo);
            setNumProducts(res.data.pedidos);
          } else if (res.data.estado == "Ok") {
            setMessage(res.data.message);
            setNumProducts(res.data.pedidos);
          }
        }, 2000);
        setstateLoad(100);
      })
      .catch((error) => {
        setEstimatedDuration(0);
        setStartTime(null);
        if (!axios.isCancel(error)) {
          if (error.response) {
            setError(error.response.data.error);
            setErrorMessage({
              titulo: "Algo ha salido mal",
              descripcion: `<p style="margin: auto 0; margin-top:5%; font-size:23px; font-weight:bold"><span>${error.response.data.error}</span></p>`,
            });
          } else {
            setError("Error en la carga masiva");
            setErrorMessage({
              titulo: "Algo ha salido mal",
              descripcion: `<p style="margin: auto 0; margin-top:5%; font-size:23px; font-weight:bold"><span>Error en la carga masiva</span></p>`,
            });
          }
          setstateLoad(100);
          setShowModal(true);
        }
      });
  };

  const calculateProgress = () => {
    if (startTime != null && estimatedDuration > 0) {
      const elapsedTime = Date.now() - startTime;
      let estimatedProgress =
        50 + ((elapsedTime / estimatedDuration) * 100) / 2;
      estimatedProgress = Math.min(estimatedProgress, 99).toFixed(2);
      setstateLoad(estimatedProgress);
    }
  };

  // Llamar a calculateProgress cada segundo para actualizar el progreso
  useEffect(() => {
    const interval = setInterval(calculateProgress, 1000);
    return () => clearInterval(interval);
  }, [startTime, estimatedDuration]);

  const getFileSize = (file) => {
    const sizeInKB = file.size / 1024;
    const duration = sizeInKB * 5 * 1000; //5 segundos por Kylobyste
    calcularAproximacionTime(file, duration);
  };

  const cargarOtroCargue = () => {
    setFile(null);
    setcontent(1);
    setstateLoad(0);
  };

  const cancelRequest = () => {
    setcontent(1);
    setstateLoad(0);
    if (cancelToken.current) {
      cancelToken.current.cancel("Solicitud cancelada por el usuario.");
    }
    cancelarCargaMasiva();
  };

  const cancelarCargaMasiva = async () => {
    axios.post(Constant.CANCELARCARGA).then(() => {
      setEstimatedDuration(0);
    });
  };

  return (
    <div className="containerCarga">
      {showModal ? (
        <ModalNotificacion
          setShowModal={setShowModal}
          notificacionSelect={errorMessage}
          img={""}
        />
      ) : null}
      {content === 1 || error ? (
        <>
          <section className="container">
            <div {...getRootProps({ className: `dropzone${handleDrop()}` })}>
              <input {...getInputProps()} />
              <p>
                {File
                  ? File.path
                  : "Arrastra el archivo aquí o busca en tu computadora"}
              </p>
            </div>
            {error ? (
              <>
                <br />
                <br />
                <aside>
                  <>
                    <h4 className="error-upload">{error}</h4>
                  </>
                  {/* <h4>Archivo</h4>
                  <ul>{files}</ul> */}
                </aside>
              </>
            ) : null}
          </section>
          <br />
          <br />
          <div className="content-btn">
            <div className="btn-import no-seleccionable" onClick={open}>
              <span>Adjuntar</span>
            </div>
            <div
              className="btn-import no-seleccionable"
              onClick={() => {
                setcontent(2);
                uploadFileNew();
              }}
            >
              <span>Iniciar carga</span>
            </div>
          </div>
        </>
      ) : content === 2 ? (
        <div className="contentLoadFile">
          <div className="topLoad">
            <span>
              {stateLoad === 100 && !error
                ? "Importado"
                : `Importando ${stateLoad}%`}
            </span>
          </div>
          <div className="content-bar">
            <div className="content-bar__label">
              <img src={IconUpload} alt="" />
              <div className="content-bar__label--bar">
                <span className="fileName">
                  {File ? File.path : "Nombre del archivo.xls"}
                </span>
                <BorderLinearProgress variant="determinate" value={stateLoad} />
              </div>
            </div>
            {stateLoad < 100 && !error ? (
              <span
                onClick={() => {
                  cancelRequest();
                }}
              >
                Cancelar carga
              </span>
            ) : null}
          </div>
          {stateLoad === 100 && !error ? (
            <div className="contentCompleta">
              <p>Archivo 100% importado por favor has clic en verificar</p>
              <div
                className="btn-verificar no-seleccionable"
                onClick={() => setcontent(3)}
              >
                <span>Verificar archivo</span>
              </div>
            </div>
          ) : (
            <p>
              Por favor espera a que el archivo sea cargado al 100% y luego has
              clic en el botón verificar
            </p>
          )}
        </div>
      ) : (
        <div className="content-result">
          <div className="header-message">
            <h1>
              <strong>¡Gracias!</strong> La carga masiva fue exitosa
            </h1>
            <p>Se han cargado {numProducts} pedidos</p>
          </div>
          <div className="header-result">
            <h2>
              <span>{response ? response.length : 0} errores</span> detectados
              en tu archivo
            </h2>
          </div>
          <div className="body-result">
            <div className="table-result">
              <div className="thead-result">
                <div>
                  <span>Fila a verificar</span>
                  <img src={arrowSimple} alt="" />
                </div>
                <div>
                  <span>Motivo del error</span>
                  <img src={arrowSimple} alt="" />
                </div>
              </div>
              <div className="tbody-result">
                {error ? <h4 className="error-upload">{error}</h4> : null}
                {response && !error ? (
                  Object.keys(response).map((item) => (
                    <div className="row-result">
                      <div>
                        <div className="recuadro">
                          <span>{response[item].fila}</span>
                        </div>
                      </div>
                      <div>
                        <span>{response[item].descripcion}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>{message ? message : ""} </p>
                )}
              </div>
            </div>
            {/**<div className="contentCompleta">
                  <p>Haz click para ver enviar el correo!</p>
                  {load ?
                      <p>...enviando correo</p> :
                      messageSend ? <p className="message-send">{messageSend}</p> :
                        <div
                          className="btn-verificar no-seleccionable"
                          onClick={() => handleSendEmail()}
                        >
                          <span className="text-btn">Enviar correo</span>
                        </div>
                  }
                </div>*/}
            <div className="tfooter">
              <button
                className="btn-verificar no-seleccionable"
                onClick={() => history.push("./MiPerfil/MisPedidos")}
              >
                <span className="text-btn">Historial de pedidos</span>
              </button>

              <button
                className="btn-verificar btn-verificar--white no-seleccionable"
                onClick={() => history.push("/Catalogo/Categoria/-1/Todos/1")}
              >
                <span className="text-btn">Regresar al catálogo</span>
              </button>

              <button
                className="btn-verificar btn-verificar--white no-seleccionable"
                onClick={() => cargarOtroCargue()}
              >
                <span className="text-btn">Cargar otro archivo</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Instrucciones = ({ setcontent }) => {
  const [Instrucciones, setInstrucciones] = useState({});

  const getInstrucciones = () => {
    axios
      .get(Constant.GETINSTRUCCIONES)
      .then((res) => {
        setInstrucciones(res.data[0]);
      })
      .catch((error) => {
        //setError(true)
      });
  };

  useEffect(() => {
    getInstrucciones();
  }, []);
  return (
    <div className="contentInstru">
      {Object.entries(Instrucciones).length !== 0 ? (
        <>
          <div className="headerInstru">
            <div>
              <h2>Instrucciones / Pasos</h2>
            </div>
            <div className="btn_cerrar" onClick={() => setcontent("carga")}>
              <span>Cerrar</span>
              <i className="fas fa-times"> </i>
            </div>
          </div>
          <div className="BodyInstru">
            <div className="contImgs">
              {Instrucciones.imagenes.map((img, i) => (
                <div className="cardImg" key={i}>
                  <img
                    src={
                      Constant.URL_BASE_IMAGES +
                      "InstructivoCargue/" +
                      img.nombre
                    }
                    alt=""
                  />
                </div>
              ))}
            </div>
            <Markup content={Instrucciones.texto} />
          </div>
        </>
      ) : (
        <div className="loader_centerPages">
          <Loader type="ThreeDots" color="#0075BB" height={100} width={100} />
        </div>
      )}
    </div>
  );
};

export default Content;
